import {
  LIST_CHANGE_ACTIVE_FILTER_STATUS,
  LIST_CLEAR_SELECTED_ROW,
  LIST_CLOSE,
  LIST_CREATE,
  LIST_EDIT,
  LIST_ERROR,
  LIST_FETCHING_DATA,
  LIST_GET_COMPANY,
  LIST_GET_NEW_DATA,
  LIST_GET_OPENED,
  LIST_INDEX,
  LIST_OPEN,
  LIST_PROGRESS,
  LIST_SELECT,
  LIST_SHOW
} from "../../typesAction";

const INITIAL_STATE = {
  items: [],
  open_rows: [],
  errorMessage: null,
  inProgress: true,
  totalItems: 0,
  filters: [],
  selectedRow: null,
  selectedRowObj: null,
  progress: {},
  currentRow: {}
};

// Split reducers https://redux.js.org/basics/reducers

// According to https://redux.js.org/basics/reducers this is might be no good.
// Given the same arguments, it should calculate the next state and return it.
// No surprises. No side effects. No API calls. No mutations. Just a calculation.
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LIST_INDEX:
      return {
        ...state,
        filters: action.payload.filters,
        items: action.payload.data["hydra:member"],
        totalItems: action.payload.data["hydra:totalItems"],
        //viewControll: action.payload.data["hydra:view"],
        errorMessage: null,
        inProgress: false
      };
    case LIST_SHOW:
      return { ...state, currentRow: action.payload, errorMessage: null, inProgress: false };
    case LIST_GET_COMPANY:
      return { ...state, errorMessage: null, inProgress: false };
    case LIST_CREATE:
      return { ...state, errorMessage: null, inProgress: false };
    case LIST_EDIT:
      return { ...state, errorMessage: null, inProgress: false };
    case LIST_GET_NEW_DATA:
      return {
        ...state,
        items: action.payload["hydra:member"],
        totalItems: action.payload["hydra:totalItems"],
        //viewControll: action.payload["hydra:view"],
        errorMessage: null,
        inProgress: false
      };
    case LIST_ERROR:
      return {
        ...state,
        errorMessage: action.payload.response.data,
        inProgress: false
      };
    case LIST_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    case LIST_CHANGE_ACTIVE_FILTER_STATUS:
      return {
        ...state,
        filters: state.filters.map(filter => {
          if (filter.propertyName === action.payload.propertyName) {
            filter.isActive = !filter.isActive;
          }
          return filter;
        })
      };
    case LIST_GET_OPENED:
      return {
        ...state,
        open_rows: action.payload,
        errorMessage: null,
        // inProgress: false
      };
    case LIST_OPEN:
      return {
        ...state,
        open_rows: action.payload,
        errorMessage: null,
      };
    case LIST_CLOSE:
      return {
        ...state,
        open_rows: action.payload.data,
        selectedRow: action.payload.selected_row,
        selectedRowObj: action.payload.selected_list_obj,
        errorMessage: null,
      };
    case LIST_SELECT:
      return { ...state, selectedRow: action.payload.id, selectedRowObj: action.payload };
    case LIST_CLEAR_SELECTED_ROW:
      return { ...state, selectedRow: action.payload, selectedRowObj: action.payload };
    case LIST_PROGRESS:
      return { ...state, progress: action.payload };
    default:
      return state;
  }
}
